import { IconeAlerte } from '@journal/ui';

/**
 * Bandeau d'une consultation par le SUPPORT.
 *
 * Le back-office ouvre l'espace d'un client en lecture seule pour reproduire
 * ce qu'il décrit dans un ticket. Le serveur refuse toute écriture à ce
 * jeton ; ce bandeau le dit, en permanence, pour que l'opérateur ne prenne pas
 * un refus pour une panne — et pour qu'une capture d'écran envoyée au client
 * ne puisse pas être confondue avec la sienne.
 */
export function BandeauImitation({ espace }: { espace: string }) {
  return (
    <div
      role="status"
      aria-label="Consultation par le support"
      className={[
        'flex items-start gap-2.5 border-b px-4 py-2.5 text-sm leading-snug',
        'border-[var(--color-border)] bg-[var(--color-danger-soft)]',
        'text-[var(--color-danger-soft-fg)] print:hidden',
      ].join(' ')}
    >
      <span aria-hidden="true" className="mt-0.5 shrink-0">
        <IconeAlerte taille={16} />
      </span>
      <p className="min-w-0 flex-1">
        <strong>Consultation support (lecture seule).</strong>{' '}
        Vous voyez l’espace « {espace} » tel que le client le voit. Aucune
        modification n’est possible ; la consultation est journalisée, dure
        quinze minutes et se referme avec cet onglet.
      </p>
    </div>
  );
}
